import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import CardMedia from "@mui/material/CardMedia";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import ReservationStatusChip from "./ReservationStatusChip";
import ReservationStatusDialog from "./ReservationStatusDialog";
import { ReservationApi } from "../api/AdminApi";
import ReservationTable from "./ReservationTable";
import { getData } from "../api/AuthenticatedApiCaller";
import { IconButton, Stack, TextField } from "@mui/material";
import {
  ArrowBackIos,
  ArrowForward,
  ArrowForwardIos,
} from "@mui/icons-material";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ReservationDetailsTable from "./ReservationDetailsTable";

function createReservations(map) {
  const rows = [];

  if (map !== undefined) {
    for (var key in map) {
      rows.push({
        id: key,
        referenceNumber: map[key]["referenceNumber"],
        pickupDate: map[key]["pickupDate"],
        pickupLocation: map[key]["pickUpLocation"],
        dropoffDate: map[key]["dropoffDate"],
        dropoffLocation: map[key]["dropOffLocation"],
        amount: map[key]["amount"],
        paymentMethod: map[key]["paymentMethod"],
        status: map[key]["status"],
      });
    }
  }
  console.log(rows);
  return rows;
}

export default function DataTable() {
  const [reservations, setReservations] = useState(null);
  const [update, setUpdate] = useState(false);
  const [reservationPage, setReservationPage] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [refRegex, setRefRegex] = useState(null);
  const [currentReservation, setCurrentReservation] = useState(null);

  useEffect(() => {
    console.log(currentReservation);
    if (reservations === null || update) {
      fetchData();
      setCurrentReservation(null);
    }
    setUpdate(false);
  }, [update]);

  async function fetchData() {
    let requestParams =
      refRegex === null
        ? "?page=" + reservationPage
        : "?page=" + reservationPage + "&refferenceNumber=" + refRegex;
    const [data, error] = await getData(ReservationApi.search + requestParams);
    if (error) {
      // Handle the error
    } else {
      setMaxPages(data.totalPages);
      setReservations(data);
    }
  }

  return (
    <Box>
      {reservations !== null && (
        <ReservationTable
          reservations={reservations.result}
          onReservationSelect={setCurrentReservation}
          onUpdate={() => setUpdate(true)}
        />
      )}
      <Stack direction="row" spacing={3}>
        <div>
          <TextField
            id="input-with-icon-textfield"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="standard"
            onChange={(event) => {
              setReservationPage(0);
              setRefRegex(
                event.target.value !== "" ? event.target.value : null
              );
              setUpdate(true);
            }}
          />
        </div>
        <div>
          <IconButton disabled={reservationPage === 0}>
            <ArrowBackIos
              onClick={() => {
                setReservationPage(reservationPage - 1);
                setUpdate(true);
              }}
            />
          </IconButton>
          <IconButton disabled={reservationPage === maxPages}>
            <ArrowForwardIos
              onClick={() => {
                setReservationPage(reservationPage + 1);
                setUpdate(true);
              }}
            />
          </IconButton>
        </div>
      </Stack>

      {currentReservation !== null && (
        <ReservationDetailsTable currentReservation={currentReservation} />
      )}
    </Box>
  );
}
